import axios, { AxiosRequestConfig } from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { LandingOutputDTO } from './landingDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'

class LandingServices {
  async getByAll(params: any): Promise<LandingOutputDTO[]> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }

      if (params) {
        config.params = params
      }
      
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/landing/`, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getSectorsByLanding(params: any): Promise<any[]> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }

      if (params) {
        config.params = params
      }
      
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/sector_by_landing/`, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getBannersBySector(): Promise<any[]> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }
      
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/banner-by-sector-landing/all`, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteSectorByLanding(sectorId: number): Promise<any[]> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }
      
      const res = await axios.delete(`${process.env.REACT_APP_URL_RESERVATION}/sector-by-landing/${sectorId}`, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteBannerBySector(data: any): Promise<any[]> {
    try {
      const res = await axios.delete(`${process.env.REACT_APP_URL_RESERVATION}/banner-by-sector-landing/`, {
        headers: { 'authentication-token': getJWT()! },
        data,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteLandingByWorkUnit(data: any): Promise<Object> {
    try {
      const res = await axios.delete(`${process.env.REACT_APP_URL_RESERVATION}/landing-by-work-unit/`, {
        headers: { 'authentication-token': getJWT()! },
        data,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteLandingByBusinessUnit(data: any): Promise<Object> {
    try {
      const res = await axios.delete(`${process.env.REACT_APP_URL_RESERVATION}/landing-by-business-unit/`, {
        headers: { 'authentication-token': getJWT()! },
        data,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async uploadImages(data: any): Promise<Object> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }
      
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/landing/images`, data, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const landingServices = new LandingServices()
